import { render, staticRenderFns } from "./TabWhatsappPhones.vue?vue&type=template&id=66e5d458&scoped=true"
import script from "./TabWhatsappPhones.vue?vue&type=script&lang=ts"
export * from "./TabWhatsappPhones.vue?vue&type=script&lang=ts"
import style0 from "./TabWhatsappPhones.vue?vue&type=style&index=0&id=66e5d458&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66e5d458",
  null
  
)

export default component.exports